import { Component } from '@angular/core';
import { CoreProvider } from 'src/app/services/core';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss']
})
export class HomePage {

}
